import React, { useState } from "react";
import OTPbox from "sushiweb/InputTypes/OTPbox";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import NoFooterModal from "../../Common/NoFooterModal";
import * as DriverAssetsActions from "../../../store/actions/DriverAssets";
import * as UserActions from "../../../store/actions/User";
import SuccessMessages from "../../../constants/SucessMessages.json";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import "./OtpDialog.scss";

const OtpDialog = (props) => {
  const {
    handleReject,
    verifyAssetsOtp,
    assetId,
    setModalAction,
    resendOtp,
    setStatus,
  } = props;
  const [otp, setOtp] = useState(null);
  const [error, setError] = useState("");
  const handleChange = (e) => {
    console.log(e.target.value);
  };
  //otp handling
  const handleAccept = (otp) => {
    setOtp(otp);
  };

  const verifyOtp = () => {
    if (otp) {
      const payload = {
        otp: otp,
        statusData: {
          asset_id: assetId,
          message: "VERIFIED",
        },
      };
      verifyAssetsOtp(payload).then((res) => {
        if (res) {
          setModalAction("payment");
        } else {
          setError("The OTP you have entered is either incorrect or expired");
        }
      });
    }
  };

  const handleResendOtp = () => {
    const payload = {
      asset_id: assetId,
    };
    resendOtp(payload).then((res) => {
      setStatus({ type: "success", message: SuccessMessages.OTP_SEND_SUCCESS });
    });
  };

  return (
    <NoFooterModal
      header={true}
      heading="OTP Verification"
      subHeading="You have requested assets issuance"
      handleClose={handleReject}
      id="OTPModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="submitButton"
            className="sushi-btn"
            onClick={verifyOtp}
          >
            Verify OTP & Pay
          </Button>
        </BottomSectionModal>
      }
    >
      <h3 className="text-gray">Enter the OTP received to proceed.</h3>
      <OTPbox
        id={"otpInput"}
        onChange={handleChange}
        length={6}
        fnInputFill={handleAccept}
        inputType="number"
      />
      {error && (
        <>
          <div className="error-state otp-error">{"*" + error}</div>
          <div onClick={handleResendOtp} className="link-state">
            Resend OTP
          </div>
        </>
      )}
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { MenuActions } = state;
  return {
    allMenuActions: MenuActions.allMenuActions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    verifyAssetsOtp: bindActionCreators(
      DriverAssetsActions.verifyOtp,
      dispatch
    ),
    resendOtp: bindActionCreators(DriverAssetsActions.resendOtp, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(OtpDialog);
